// This file is automatically generated. Do not edit manually.

import { CustomerOrderView } from "src/api/generated/erp/db/types/tables/customerOrderView";
import { CustomerOrderState } from "src/api/generated/erp/db/types/enums/customerOrderState";
import { ServerSideDataModelRequest } from "src/api/generated/common/dataGrids/serverSideDataModelRequest";
import { ServerSideDataModelResult } from "src/api/generated/common/dataGrids/serverSideDataModelResult";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerOrderApi {
	export async function getCustomerOrder(args: {
		customerOrderId: number;
	}): Promise<CustomerOrderView> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/getCustomerOrder",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
			},
		});
		return response as CustomerOrderView;
	}

	export async function searchCustomerOrders(args: {
		states?: Array<CustomerOrderState>;
		searchQuery?: string;
		dataModelRequest?: ServerSideDataModelRequest;
	}): Promise<ServerSideDataModelResult<CustomerOrderView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/searchCustomerOrders",
			method: "POST",
			data: {
				states: args.states,
				searchQuery: args.searchQuery,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as ServerSideDataModelResult<CustomerOrderView>;
	}
}
